(()=>{const root=window.document.getElementById('stikkma-hats-v1');if(!root)return;
const resolve=window.StikkmaHatAssets.resolve,Image=window.StikkmaHatAssets.Image,fetch=window.StikkmaHatAssets.fetch;
const document=new Proxy(window.document,{get(t,p){if(p==='querySelector')return s=>root.querySelector(s);if(p==='querySelectorAll')return s=>root.querySelectorAll(s);if(p==='getElementById')return id=>root.querySelector('#'+CSS.escape(id));const v=Reflect.get(t,p,t);return typeof v==='function'?v.bind(t):v;}});
(function (global) {
  'use strict';
  var STYLES = Object.freeze({nordic: 'Ausgefüllt', line: 'Als Kontur'});
  var LEGACY = Object.freeze({heart: 'Herz', mountain: 'Berglinie', paw: 'Pfote'});
  function finite(value, fallback) {
    return Number.isFinite(Number(value)) ? Number(value) : fallback;
  }
  function fold(value) {
    return String(value || '').toLocaleLowerCase('de').normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '').replace(/ß/g, 'ss')
      .replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u');
  }
  function rectangle(value, name, allowNegative) {
    if (!value || !['x', 'y', 'w', 'h'].every(function (k) { return Number.isFinite(value[k]); }) ||
        (!allowNegative && (value.x < 0 || value.y < 0)) || value.w <= 0 || value.h <= 0) {
      throw new TypeError((name || 'sourceRect') + ' must have finite x/y >= 0 and positive w/h');
    }
    return Object.freeze({x: value.x, y: value.y, w: value.w, h: value.h});
  }
  function fitRect(source, target, alignment) {
    if (!source || !Number.isFinite(source.w) || !Number.isFinite(source.h) || source.w <= 0 || source.h <= 0) {
      throw new TypeError('Source size must be positive');
    }
    var t = rectangle(target, 'targetRect', true);
    var factor = Math.min(t.w / source.w, t.h / source.h);
    var w = source.w * factor, h = source.h * factor;
    var a = alignment || {x: 0.5, y: 0.5};
    var ax = Math.max(0, Math.min(1, finite(a.x, 0.5)));
    var ay = Math.max(0, Math.min(1, finite(a.y, 0.5)));
    return {x: t.x + (t.w - w) * ax, y: t.y + (t.h - h) * ay, w: w, h: h};
  }
  function overlaps(a, b, gap) {
    return !!b && a.x < b.x + b.w + gap && a.x + a.w > b.x - gap &&
      a.y < b.y + b.h + gap && a.y + a.h > b.y - gap;
  }
  function placeMotif(options) {
    var o = options || {}, r = rectangle(o.region, 'region', true);
    var source = o.sourceSize || {w: 1, h: 1};
    if (!Number.isFinite(source.w) || !Number.isFinite(source.h) || source.w <= 0 || source.h <= 0) {
      throw new TypeError('Source size must be positive');
    }
    var gap = Math.max(0, finite(o.gap, 10));
    var scale = Math.max(0.05, finite(o.scale, 1));
    var nominal = Math.max(1, finite(o.width, 82) * scale);
    var text = o.textBox ? rectangle(o.textBox, 'textBox', true) : null;
    var position = ['above', 'below', 'left', 'right'].indexOf(o.position) >= 0 ? o.position : 'above';
    function area(side) {
      if (!text) return r;
      if (side === 'above') return {x: r.x, y: r.y, w: r.w, h: Math.max(0, text.y - gap - r.y)};
      if (side === 'below') return {x: r.x, y: text.y + text.h + gap, w: r.w, h: Math.max(0, r.y + r.h - text.y - text.h - gap)};
      if (side === 'left') return {x: r.x, y: r.y, w: Math.max(0, text.x - gap - r.x), h: r.h};
      return {x: text.x + text.w + gap, y: r.y, w: Math.max(0, r.x + r.w - text.x - text.w - gap), h: r.h};
    }
    function inside(a) {
      a = {x: Math.max(r.x, a.x), y: Math.max(r.y, a.y),
        w: Math.min(a.w, r.x + r.w - a.x), h: Math.min(a.h, r.y + r.h - a.y)};
      if (a.w <= 0 || a.h <= 0) return null;
      var wantW = Math.min(a.w, nominal), wantH = wantW / source.w * source.h;
      if (wantH > a.h) { wantH = a.h; wantW = wantH / source.h * source.w; }
      return {x: a.x + (a.w - wantW) / 2, y: a.y + (a.h - wantH) / 2, w: wantW, h: wantH};
    }
    var preferred = inside(area(position));
    var candidates = ['above', 'below', 'left', 'right'].map(function (side) {
      var box = inside(area(side));
      return box ? {box: box, side: side} : null;
    }).filter(Boolean);
    if (o.manual && Number.isFinite(o.manual.x) && Number.isFinite(o.manual.y)) {
      var dims = inside(r);
      var manual = {x: Math.max(r.x, Math.min(r.x + r.w - dims.w, o.manual.x - dims.w / 2)),
        y: Math.max(r.y, Math.min(r.y + r.h - dims.h, o.manual.y - dims.h / 2)),
        w: dims.w, h: dims.h};
      if (!overlaps(manual, text, gap)) return Object.assign(manual, {position: position, adjusted: false, overlap: false});
      candidates.sort(function (a, b) {
        return Math.hypot(a.box.x + a.box.w / 2 - o.manual.x, a.box.y + a.box.h / 2 - o.manual.y) -
          Math.hypot(b.box.x + b.box.w / 2 - o.manual.x, b.box.y + b.box.h / 2 - o.manual.y);
      });
      if (candidates.length) return Object.assign(candidates[0].box, {position: candidates[0].side, adjusted: true, overlap: false});
      return {x: r.x, y: r.y, w: 0, h: 0, position: position, adjusted: true, overlap: true};
    }
    if (preferred && !overlaps(preferred, text, gap - 0.001)) {
      return Object.assign(preferred, {position: position, adjusted: false, overlap: false});
    }
    candidates.sort(function (a, b) { return b.box.w * b.box.h - a.box.w * a.box.h; });
    if (candidates.length) return Object.assign(candidates[0].box, {position: candidates[0].side, adjusted: true, overlap: false});
    return {x: r.x, y: r.y, w: 0, h: 0, position: position, adjusted: true, overlap: true};
  }
  function paginate(items, page, size) {
    var limit = Math.max(1, Math.min(24, Math.floor(finite(size, 12))));
    var count = Math.max(1, Math.ceil(items.length / limit));
    var current = Math.max(0, Math.min(count - 1, Math.floor(finite(page, 0))));
    return {items: items.slice(current * limit, (current + 1) * limit),
      page: current, pageSize: limit, pageCount: count, total: items.length};
  }
  function MotifLibrary(options) {
    this.options = options || {};
    this.version = '';
    this.baseURL = '';
    this.motifs = [];
    this.categories = [];
    this.byId = new Map();
    this.images = new Map();
    this.materials = new Map();
    this.loaded = false;
  }
  MotifLibrary.prototype.load = async function (input, options) {
    var o = typeof options === 'string' ? {baseURL: options} : options || {}, base = o.baseURL || this.options.baseURL ||
      (typeof document !== 'undefined' ? document.baseURI : 'https://example.invalid/');
    var data = input;
    if (typeof input === 'string' || input instanceof URL) {
      var url = new URL(String(input), base).href;
      var fetcher = o.fetch || this.options.fetch || fetch;
      if (!fetcher) throw new Error('A fetch implementation is required');
      var response = await fetcher(url);
      if (!response.ok) throw new Error('Motif library could not be loaded (' + response.status + ')');
      data = await response.json();
      base = new URL('.', url).href;
    }
    if (!data || typeof data.version !== 'string' || !Array.isArray(data.categories) || !Array.isArray(data.motifs)) {
      throw new TypeError('A version, categories array and motifs array are required');
    }
    var categoryMap = new Map(), map = new Map();
    data.categories.forEach(function (c) {
      if (!c || typeof c.id !== 'string' || !c.id || typeof c.label !== 'string' || !c.label || categoryMap.has(c.id)) {
        throw new TypeError('Categories require unique ids and labels');
      }
      categoryMap.set(c.id, Object.freeze({id: c.id, label: c.label}));
    });
    var motifs = data.motifs.map(function (m) {
      if (!m || typeof m.id !== 'string' || !m.id || m.id === 'none' || map.has(m.id) ||
          typeof m.label !== 'string' || !m.label || !categoryMap.has(m.categoryId)) {
        throw new TypeError('Motifs require unique ids, labels and an existing category');
      }
      var styles = {};
      Object.keys(STYLES).forEach(function (style) {
        var asset = m.styles && m.styles[style];
        if (!asset || typeof asset.src !== 'string' || !asset.src) throw new TypeError(m.id + ' requires ' + style + ' source');
        styles[style] = Object.freeze({
          src: new URL(asset.src, base).href,
          sourceRect: rectangle(asset.sourceRect),
          previewMaterial: asset.previewMaterial === 'flat-line' ? 'flat-line' : 'raster-embroidery',
          sourceReference: asset.sourceReference || m.sourceReference || m.id
        });
      });
      var tags = Array.isArray(m.tags) ? m.tags.filter(function (s) { return typeof s === 'string'; }) : [];
      var maxDimension = Math.max(1, finite(m.recommendedMaxDimensionMm, 50));
      var mainRect = styles.nordic.sourceRect;
      var physicalScale = maxDimension / Math.max(mainRect.w, mainRect.h);
      var item = Object.freeze({
        id: m.id, label: m.label, categoryId: m.categoryId, categoryLabel: categoryMap.get(m.categoryId).label,
        tags: Object.freeze(tags), recommendedMaxDimensionMm: maxDimension,
        recommendedWidthMm: mainRect.w * physicalScale, recommendedHeightMm: mainRect.h * physicalScale,
        styles: Object.freeze(styles),
        searchText: fold([m.label, categoryMap.get(m.categoryId).label].concat(tags).join(' '))
      });
      map.set(item.id, item);
      return item;
    });
    this.version = data.version;
    this.baseURL = base;
    this.motifs = motifs;
    this.byId = map;
    this.categories = Array.from(categoryMap.values()).map(function (cat) {
      return Object.freeze(Object.assign({}, cat, {count: motifs.filter(function (m) { return m.categoryId === cat.id; }).length}));
    });
    this.images.clear();
    this.materials.clear();
    this.loaded = true;
    return this;
  };
  MotifLibrary.prototype.get = function (id) { return this.byId.get(id) || null; };
  MotifLibrary.prototype.search = function (query, categoryId) {
    var words = fold(query).trim().split(/\s+/).filter(Boolean);
    return this.motifs.filter(function (m) {
      return (!categoryId || categoryId === 'all' || m.categoryId === categoryId) &&
        words.every(function (word) { return m.searchText.indexOf(word) >= 0; });
    });
  };
  MotifLibrary.prototype.prepare = function (id, style) {
    var motif = this.get(id), self = this;
    if (!motif || !STYLES[style]) return Promise.reject(new Error('Unknown motif or style'));
    var asset = motif.styles[style], cached = this.images.get(asset.src);
    if (!cached) {
      var entry = {image: null, promise: null};
      entry.promise = new Promise(function (resolve, reject) {
        var img = self.options.imageFactory ? self.options.imageFactory() : new Image();
        img.decoding = 'async';
        img.onload = function () {
          entry.image = img;
          resolve(img);
          if (global.dispatchEvent && global.CustomEvent) {
            global.dispatchEvent(new global.CustomEvent('stikkma-motif-ready', {detail: {src: asset.src}}));
          }
        };
        img.onerror = function () { self.images.delete(asset.src); reject(new Error('Motif image could not be loaded')); };
        img.src = asset.src;
      });
      this.images.set(asset.src, entry);
      cached = entry;
    }
    return cached.promise.then(function (img) {
      var b = asset.sourceRect;
      if (b.x + b.w > img.naturalWidth + 0.01 || b.y + b.h > img.naturalHeight + 0.01) {
        throw new RangeError('sourceRect extends outside its atlas: ' + id + '/' + style);
      }
      return img;
    });
  };
  MotifLibrary.prototype.draw = function (ctx, id, style, targetRect, options) {
    var motif = this.get(id);
    if (!motif || !STYLES[style]) return null;
    var asset = motif.styles[style], entry = this.images.get(asset.src);
    if (!entry || !entry.image) return null;
    var b = asset.sourceRect, image = entry.image;
    if (b.x + b.w > image.naturalWidth || b.y + b.h > image.naturalHeight) return null;
    var opts = options || {}, dest = fitRect(b, targetRect, opts.alignment || opts);
    // Show the actual approved embroidery bitmap, without synthetic line textures.
    ctx.drawImage(image, b.x, b.y, b.w, b.h, dest.x, dest.y, dest.w, dest.h);
    return dest;
  };
  MotifLibrary.prototype.loadImage = MotifLibrary.prototype.prepare;
  MotifLibrary.prototype.selection = function (id, style) {
    if (!id || id === 'none') return Object.freeze({motifId: 'none', motifStyle: STYLES[style] ? style : 'nordic'});
    var motif = this.get(id);
    if (!motif || !STYLES[style]) throw new TypeError('Unknown motif selection');
    var b = motif.styles[style].sourceRect;
    var scale = motif.recommendedMaxDimensionMm / Math.max(b.w, b.h);
    return Object.freeze({motifId: motif.id, motifStyle: style, motifLabel: motif.label,
      categoryId: motif.categoryId, libraryVersion: this.version,
      sourceReference: motif.styles[style].sourceReference, recommendedMaxDimensionMm: motif.recommendedMaxDimensionMm,
      recommendedWidthMm: b.w * scale, recommendedHeightMm: b.h * scale});
  };
  MotifLibrary.prototype.cartProperties = function (selection) {
    var s = this.selection(selection.motifId, selection.motifStyle);
    if (s.motifId === 'none') return {};
    return {'_Motiv-ID': s.motifId, 'Motiv': s.motifLabel, 'Motivstil': STYLES[s.motifStyle],
      '_Motivbibliothek': s.libraryVersion, '_Motivquelle': String(s.sourceReference),
      '_Motivempfehlung-Breite-mm': String(Math.round(s.recommendedWidthMm * 10) / 10),
      '_Motivempfehlung-Hoehe-mm': String(Math.round(s.recommendedHeightMm * 10) / 10)};
  };
  function migrateSelection(saved, library, aliases) {
    var id = saved && (saved.motifId || saved.motiveId || saved.motif) || 'none';
    var style = saved && (saved.motifStyle || saved.style) || 'nordic';
    if (!STYLES[style]) style = 'nordic';
    if (typeof id !== 'string') return {motifId: 'none', motifStyle: style, invalidOriginalId: '[invalid-type:' + typeof id + ']'};
    if (id === 'none') return {motifId: 'none', motifStyle: style};
    if (library.get(id)) return library.selection(id, style);
    var legacy = id.indexOf('legacy:') === 0 ? id.slice(7) : id;
    if (LEGACY[legacy]) {
      if (aliases && library.get(aliases[legacy])) return library.selection(aliases[legacy], style);
      return {motifId: 'legacy:' + legacy, motifStyle: 'line', legacyKind: legacy, motifLabel: LEGACY[legacy]};
    }
    return {motifId: 'none', motifStyle: style, invalidOriginalId: id};
  }
  function hasMotif(config, library) {
    var s = migrateSelection(config, library);
    return s.motifId !== 'none' && !s.invalidOriginalId;
  }
  var exported = {MotifLibrary: MotifLibrary, styles: STYLES, fold: fold, fitRect: fitRect,
    placeMotif: placeMotif, paginate: paginate, migrateSelection: migrateSelection, hasMotif: hasMotif};
  if (typeof module !== 'undefined' && module.exports) module.exports = exported;
  if (global.document) {
    global.StikkmaMotifs = new MotifLibrary();
    global.StikkmaMotifTools = exported;
  }
})(typeof window !== 'undefined' ? window : globalThis);

})();
